import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import TopNavigator from "../components/TopNavigator";
import { API_BASE_URL, apiUrl } from "../config/api";

function GalleryDetailPage() {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [liked, setLiked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadGalleryItem = async () => {
      try {
        const response = await fetch(apiUrl("/api/content/gallery"));
        const data = await response.json();

        if (!response.ok) {
          throw new Error("خطا در دریافت گالری");
        }

        const selected = Array.isArray(data)
          ? data.find((galleryItem) => String(galleryItem.id) === String(id))
          : null;

        if (!selected) {
          throw new Error("آیتم گالری پیدا نشد.");
        }

        setItem(selected);
      } catch (err) {
        setError(err.message || "خطا در دریافت آیتم گالری");
      } finally {
        setLoading(false);
      }
    };

    loadGalleryItem();
  }, [id]);

  const handleLike = async () => {
    if (!item || liked) return;

    try {
      const response = await fetch(apiUrl(`/api/content/gallery/${item.id}/like`), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });

      if (response.ok) {
        setItem((prev) => ({ ...prev, likes: Number(prev.likes || 0) + 1 }));
        setLiked(true);
      }
    } catch (err) {
      console.error("Error liking:", err);
    }
  };

  const formatNumber = (num) => Number(num || 0).toLocaleString("fa-IR");

  return (
    <div className="MainPageShell">
      <TopNavigator />
      <main className="container GalleryDetailPage">
        {loading ? (
          <p className="UserPortalEmpty">در حال دریافت گالری...</p>
        ) : error ? (
          <p className="UserPortalEmpty UserPortalError">{error}</p>
        ) : (
          <article className="GalleryDetailCard">
            <div className="GalleryDetailImageWrap">
              <img src={`${API_BASE_URL}${item.imageUrl}`} alt={item.title || ""} />
              <button
                type="button"
                className={liked ? "GalleryImageLike liked" : "GalleryImageLike"}
                onClick={handleLike}
                aria-label="پسندیدن"
              >
                <span className="font14">{formatNumber(item.likes)}</span>
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M12 21.35 10.55 20.03C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35Z" />
                </svg>
              </button>
            </div>

            <div className="GalleryDetailInfo">
              <span className="MainPagePanelEyebrow">زرگری آنتیک</span>
              <h1>{item.title || "بدون عنوان"}</h1>
              {item.description && <p className="GalleryDetailDescription">{item.description}</p>}

              <div className="GalleryDetailContactActions">
                <a href="sms:09220382792">ارسال پیامک</a>
                <a href="tel:09220382792">تماس تلفنی</a>
              </div>
            </div>
          </article>
        )}
      </main>
    </div>
  );
}

export default GalleryDetailPage;
